import { setCartItems } from 'dibs-buyer-layout/src/actions/cartActions';
import { actionCreators } from 'dibs-buyer-layout/src/actions/';

const { setUserTypeTrade } = actionCreators;

export { setCartItems, setUserTypeTrade };
